import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { TranslateService } from '@ngx-translate/core';
import { WebApiService } from 'src/app/shared/service/webapi.service';

@Component({
  selector: 'app-edit-excludevendor',
  templateUrl: './edit-excludevendor.component.html',
  styleUrls: ['./edit-excludevendor.component.scss']
})
export class EditExcludevendorComponent implements OnInit {
  @Input() isEdit: boolean = false;
  @Output() close = new EventEmitter<any>();
  validateForm: FormGroup;
  @Input() editData: any;
  @Output() save = new EventEmitter<any>();
  fileList: NzUploadFile[] = [];
  loading: boolean = false;
  UploadFlag: boolean = false;
  IsSubmit: boolean = true;
  IsInputValue: boolean = false;
  uploading = false;
  UploadProofFile: NzUploadFile = null;
  inputvalue: string;
  constructor(private fb: FormBuilder,
    private EnvironmentconfigService: EnvironmentconfigService,
    private NzMessageService: NzMessageService,
    private AuthService: AuthService,
    private http: HttpClient,
    private tanslateService: TranslateService,
    private webApiService: WebApiService
  ) { }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      Lock: [''],
      Site: [''],
      VendorCode: [''],
      VendorName: [''],
      ExcludeVendorReason: [''],
    });

    this.IsSubmit = true;
    this.IsInputValue = false;
    this.UploadFlag = false;

    if (this.editData) {
      this.validateForm.controls['Lock'].setValue(this.editData['lock']);
      this.validateForm.controls['Site'].setValue(this.editData['site']);
      this.validateForm.controls['VendorCode'].setValue(this.editData['vendorCode']);
      this.validateForm.controls['VendorName'].setValue(this.editData['vendorName']);
      this.validateForm.controls['ExcludeVendorReason'].setValue(this.editData['excludeVendorReason']);

      if (this.editData['excludeVendorReason']) {
        this.inputvalue = this.editData['excludeVendorReason'];
        this.IsInputValue = true;
      }
      if (this.editData['proofFile']) {
        const fileName = this.editData['proofFileName'] || this.editData['fileName'] || 'ProofFile.xlsx';
        this.fileList = [{
          uid: '1',
          name: fileName,
          status: 'done'
        }];
        this.UploadFlag = true;
      }
    }
    this.validateForm.controls['Site'].disable();
    this.validateForm.controls['VendorCode'].disable();
    this.validateForm.controls['VendorName'].disable();
  }

  onClose(): void {
    this.close.emit();
    if (!this.isEdit) {
      this.resetForm();
    }
  }

  resetForm(): void {
    this.validateForm.reset();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsPristine();

      this.validateForm.controls[key].updateValueAndValidity();
    }
  }

  submitForm = ($event: any, value: any) => {
    $event.preventDefault();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    let obj = {};
    obj["Lock"] = this.validateForm.controls["Lock"].value;
    obj["Site"] = this.validateForm.controls["Site"].value;
    obj["VendorCode"] = this.validateForm.controls["VendorCode"].value;
    obj["VendorName"] = this.validateForm.controls["VendorName"].value;
    obj["ExcludeVendorReason"] = this.validateForm.controls["ExcludeVendorReason"].value;
    if (this.editData) {
      obj = Object.assign(this.editData, obj);
    }

    this.loading = true;
    if (this.UploadProofFile) {
      this.saveExcelData(this.UploadProofFile).subscribe(
        (res: any) => {
          this.loading = false;
          if (res['body'].status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
            this.NzMessageService.success(res['body'].msg);
            this.UploadFlag = true;
            this.save.emit(obj);
          } else {
            this.NzMessageService.warning(res['body'].msg);
          }
        },
        (error) => {
          this.loading = false;
          this.NzMessageService.error('upload failed.');
        }
      );
    } else {
      this.save.emit(obj);
      // Wait for parent to handle close/loading? Current logic just emits.
    }
  };

  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileList = [file];
    this.UploadProofFile = file;
    this.UploadFlag = true;
    return false;
  };

  onDownload = (file: NzUploadFile) => {
    if (file.uid === '1' && this.editData && this.editData['proofFile']) {
      this.loading = true;
      this.webApiService.downloadFileByToken(this.editData['proofFile']).subscribe(
        (res) => {
          this.downloadFile(res, file.name);
          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error(error.msg || 'Download failed');
          this.loading = false;
        }
      );
    }
  };

  downloadFile(blob: Blob, fileName: string) {
    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
    } else {
      const aLink = document.createElement('a');
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('click', true, true);
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      URL.revokeObjectURL(aLink.href);
    }
  }

  saveExcelData(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', 'proof ');
    formData.append('vendorcode', this.editData['vendorCode']);
    formData.append('excludereason', this.inputvalue);
    formData.append('category', "VendorDisqualificationDocs");/* 排除厂商佐证文件分类 */
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.UploadProofFile.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    return this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse));
  }


  IsSaveData() {
    if (this.IsInputValue == true && this.UploadFlag == true) {
      return false;
    }
    return true;
  }
  getInputvalue(Input) {
    if (Input != null && Input != '' && Input != undefined) {
      this.inputvalue = Input;
      this.IsInputValue = true;
    }
  }

  // getProofFile(file: NzUploadFile)
  // {
  //   this.UploadProofFile=file
  //   return file;
  // }




}
